import { gpHome } from '../app';
import { CurrentUserService } from '../../app-common/services/current-user-service';
import { IAuthService } from '../services/auth-service';
import { gpHasFeature, isAiV2FeatureFlagEnabled } from '../../app-common/util/feature-flags';
import {
    AccountRefreshAllEvent,
    AccountPanelBusyEvent,
    AccountPanelBusyPayload,
    applyPanelBusy,
    anyPanelBusy,
} from '../services/account-refresh-contract';

import type * as ng from 'angular';
import accountTemplate from '../views/account.html';

interface IAccountControllerScope extends ng.IScope {
    email: string;
    showLicenseInfo: boolean;

    changeEmailShowing: boolean;
    changeEmailNewAddress: string;
    changeEmailInfoMessage: string;
    changeEmailErrorMessage: string;
    changeEmailSubmitRequest(): void;

    showSelfServiceLicenseManager: boolean;
    showAiCredits: boolean;

    /** True while any panel is fetching, so the header button can show it. */
    refreshingAll: boolean;
    refreshAll(): void;
}

export const AccountController_ServiceName = "gpHome_AccountController";
export const AccountController_Template = accountTemplate;

gpHome.controller(AccountController_ServiceName, ['$scope', '$location', '$timeout', '$q', '$rootScope', 'authService', CurrentUserService.serviceName,
    function ($scope: IAccountControllerScope, $location: ng.ILocationService, $timeout: ng.ITimeoutService, $q: ng.IQService, $rootScope: ng.IRootScopeService, authService: IAuthService, accountsService: CurrentUserService) {
        new AccountController($scope, $q, $location, $rootScope, authService, accountsService)
    }]);

class AccountController {

    constructor(
        private $scope: IAccountControllerScope,
        private $q: ng.IQService, $location: ng.ILocationService,
        $rootScope: ng.IRootScopeService,
        private authService: IAuthService,
        private accountsService: CurrentUserService) {

        $scope.showLicenseInfo = false;
        $scope.refreshingAll = false;

        // "Refresh all": the header owns one button, the panels own their fetches.
        // Each reports busy/idle as it goes, so the spinner runs for exactly as long
        // as work is actually in flight rather than for a guessed interval.
        let busyPanels: Record<string, boolean> = {};

        $scope.refreshAll = () => $rootScope.$broadcast(AccountRefreshAllEvent);

        $scope.$on(AccountPanelBusyEvent, (_event: ng.IAngularEvent, payload: AccountPanelBusyPayload) => {
            busyPanels = applyPanelBusy(busyPanels, payload);
            $scope.refreshingAll = anyPanelBusy(busyPanels);
        });

        $scope.showSelfServiceLicenseManager = gpHasFeature('selfServiceLicenseManager')
        $scope.showAiCredits = isAiV2FeatureFlagEnabled();

        authService.checkAuthorisationIfNeeded().then(authInfo => {
            $scope.email = authInfo.email;
        });

        accountsService.getSubscriptionInfo().then(info => {
            $scope.showLicenseInfo = info.showLicenseOptions;
        });


        $scope.changeEmailSubmitRequest = () => {

            $scope.changeEmailInfoMessage = "";
            $scope.changeEmailErrorMessage = "";

            if ($scope.changeEmailNewAddress === $scope.email) {
                $scope.changeEmailErrorMessage = "Please type a different email address.";

            } else if ($scope.changeEmailNewAddress) {
                var req = this.accountsService.requestEmailChange($scope.email, $scope.changeEmailNewAddress);

                req.then(msg => $scope.changeEmailInfoMessage = msg);
                req.catch(reason => $scope.changeEmailErrorMessage = reason);
            } else {
                $scope.changeEmailErrorMessage = "Please type in an email address.";
            }
        }
    }
} 
